<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
import moment from 'moment'

export default {
    data() {
        return {
            tableData: [],
            currentPage: 1,
            pageSize: 50,
            total: 0,
            filterDrawer: false,
            filter: {
                status: '',
                prizeName: '',
                username: '',
                exchangeTimeStart: '',
                exchangeTimeEnd: '',
            },
            datetimeRange: [],
            showShipmentStatusDialog: false,
            currentPrize: {}
        };
    },
    methods: {
        init() {
            this.getExchangeList()
        },
        async getExchangeList(isExport = 0) {
            let params = Object.assign(this.filter, {
                access_token: localStorage.getItem("access_token"),
                page: this.currentPage,
                limit: this.pageSize,
                isExport,
                exchangeTimeStart: this.datetimeRange[0],
                exchangeTimeEnd: this.datetimeRange[1],
            })
            
            // 如果没有使用时间筛选，删除时间字段
            if(!params.exchangeTimeStart) {
                delete params.exchangeTimeStart
                delete params.exchangeTimeEnd
            // 如果使用了时间筛选,将时间数据格式化
            }else {
                params.exchangeTimeStart = moment(params.exchangeTimeStart).format('YYYY-MM-DD HH:mm:ss')
                params.exchangeTimeEnd = moment(params.exchangeTimeEnd).format('YYYY-MM-DD HH:mm:ss')
            }

            let data = await this.api.getExchangeList(params)
            if(data) {
                data.data.forEach(item => {
                    item.isCancel = moment().isBefore(item.deadlineCancleShippingTime)
                })
                this.tableData = data.data
                this.total = data.total
            }
        },
        sizeChange(pageSize) {
            this.pageSize = pageSize;
            this.currentPage = 1
            this.getExchangeList()
        },
        currentChange(currentPage) {
            this.currentPage = currentPage
            this.getExchangeList()
            this.tableScrollTop()
        },
        viewLog(params = {}) {
            this.$router.push({ path: 'exchange-record-detail', query: params })
        },
        closeFilterDrawer() {
            this.filterDrawer = false
        },
        async searchClick() {
            this.currentPage = 1

            await this.getExchangeList()
            this.filterDrawer = false
        },
        clearFilter() {
            this.filter = {
                status: '',
                prizeName: '',
                username: '',
                exchangeTimeStart: '',
                exchangeTimeEnd: '',
            }
            this.datetimeRange = []
        },
        async setStatus(item) {
            this.currentPrize = item

            if(item.status === '0') {
                this.showShipmentStatusDialog = true
            }else {
                // 取消发货
                await this.api.setShipping({
                    access_token: localStorage.getItem("access_token"),
                    exchangeId: item.id,
                    type: 2
                })

                this.statusChange('0')
                this.$message({ type: 'success', message: '已设为"待发货"状态' })
                this.visible = false
            }
        },
        statusChange(type) {
            this.currentPrize.status = type
        }
    },
    created() {
        this.init()
    },
};
</script>
